import { IGroupedFires } from 'lib_ts/interfaces/data/i-pitch-performance';

export interface IPitchPerfPlot {
  groups: IGroupedFires[];
  // only used for HWD when we provide the RT fires to draw for comparison
  refGroups: IGroupedFires[] | undefined;

  // e.g. for turning on/off the HWD legend
  isHwDiagnostic?: boolean;

  // todo: this can probably be deprecated if we always set the colors based on current flag
  // while drilling down, lower the opacity of previous MS group(s) to differentiate them from the current MS group
  highlightCurrent?: boolean;
}

// #d9edff
export const PREVIOUS_MS_FILL = '217,237,255';

// #f1f7fe
export const PREVIOUS_MS_STROKE = '241,247,254';

export interface IScatterShape {
  cx?: number;
  cy?: number;
  opacity?: number;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

// unit is whatever is being plotted
export interface IPlotCoords {
  x: number;
  y: number;
}

export interface IPlotHoverKeys {
  // value published while this mark is hovered
  itemKey?: string;
  // marks stay bright when the hovered key is in this list
  highlightKeys?: string[];
}

// dotted lines connecting points (e.g. value to target)
export interface IPlotCoordsLine extends IPlotHoverKeys {
  key: string;
  from: IPlotCoords;
  to: IPlotCoords;
  rgb: string;
}

export interface IBreakPoint extends IPlotCoords, IPlotHoverKeys {
  fillRgb: string;
  strokeRgb: string;

  pitchName: string;

  // matching_hash from the target ms
  msHash: string | undefined;

  // not defined for targets or averages
  shotId: string | undefined;

  // use the root values for target points if true, otherwise use the target property if provided
  isTarget: boolean;

  target?: IPlotCoords;
  // value minus target, not defined for targets
  delta?: IPlotCoords;
}

// showing the limit about some target
export interface IPlotThresholdCircle extends IPlotCoords, IPlotHoverKeys {
  key: string;
  rgb: string;

  // unit is whatever is being plotted
  radius: number;
}
export interface IScatterShapeBreakPoint extends IScatterShape {
  payload?: IBreakPoint;
}

export interface IPlatePoint extends IPlotCoords, IPlotHoverKeys {
  fillRgb: string;
  strokeRgb: string;

  pitchName: string;

  // matching_hash from the target ms
  msHash: string | undefined;

  // not defined for targets or averages
  shotId: string | undefined;

  isTarget: boolean;

  target?: IPlotCoords;
  // value minus target, not defined for targets
  delta?: IPlotCoords;

  // for centered plots, the value and the delta are the same, so we only show the delta badges
  onlyShowDeltas?: boolean;
}

export interface IScatterShapePlatePoint extends IScatterShape {
  payload?: IPlatePoint;
}
